export default __webpack_public_path__ + "assets/front/scss/editorial.b8e6ebb8b9e42bb9288c8ed7774d9596.css";